<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card class="md-card-plain">
          <md-card-header data-background-color="green">
            <h4 class="title">
              Apps
            </h4>
            <p class="category">
              List of all Apps
            </p>
          </md-card-header>
          <md-card-content>
            <store-table />
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
    import { StoreTable } from "@/components";

    export default {
        name: "StorePage",
        components: {
            StoreTable
        },
        data() {
            return {
                componentKey: 0,
            };
        },
        methods: {
            rerenderTable() {
                this.componentKey += 1;
            },
        }
    };
</script>

<style lang="scss">
    .new-node-dialog {
        padding: 50px 100px;
    }

    .md-dialog-container {
        width: 1200px;
    }

    .shake-on-error .md-duplicated {
        animation-name: shake;
        animation-duration: 0.5s;
    }

    @keyframes shake {
        0% {
            transform: translate(15px);
        }
        20% {
            transform: translate(-15px);
        }
        40% {
            transform: translate(7px);
        }
        60% {
            transform: translate(-7px);
        }
        80% {
            transform: translate(3px);
        }
        100% {
            transform: translate(0px);
        }
    }
</style>

<style lang="css">
    .pulse-on-error >>> .md-duplicated {
        animation-name: pulse;
        animation-duration: 0.5s;
        animation-iteration-count: infinite;
        animation-direction: alternate;
        animation-timing-function: ease-in-out
    }

    @keyframes pulse {
        0% {
            transform: scale(1.1, 1.1);
        }
        100% {
            transform: scale(0.9, 0.9);
        }
    }
</style>
